import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noMatches: {
		id: 'portfolio-3-portfolio.common.form-renderer.members-select.no-matches',
		defaultMessage: 'No matches',
		description: 'label for no users match',
	},
});
